export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-300/40">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <span className="text-2xl font-heading font-bold bg-primary-500 text-background-50 px-3 py-1 rounded-md inline-block mb-4 whitespace-nowrap">
              黑料
            </span>
            <p className="text-sm text-foreground-600 leading-relaxed mt-4">
              黑料不打烊在线观看平台，每日持续更新黑料在线视频、黑料每日大赛等新鲜内容，支持黑料网免费观看，随时随地畅享不打烊的黑料视频体验。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '热门精选', href: '#cards' },
                { label: '热度榜单', href: '#ranking' },
                { label: '焦点专题', href: '#carousel' },
                { label: '精彩视频', href: '#media' },
                { label: '最新动态', href: '#updates' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Service */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">服务支持</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '常见问答', href: '#faq' },
                { label: '联系我们', href: '#contact' },
                { label: '关于黑料', href: '#about' },
                { label: '平台特色', href: '#features' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Partners */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-background-300/40 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 黑料 - 不打烊在线观看平台。本站内容仅供娱乐参考。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}